import theme from "@/theme";

export const styles = {
  appBar: {
    padding: "1rem 2.5rem 1rem",
    marginBottom: "1rem",
    borderColor: "divider",
    bgcolor: "white",
  },

  appBarContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  disabledSelect: {
    height: "2.5rem",
    textTransform: "capitalize",
    fontSize: "0.875rem",
    lineHeight: "1.5rem",
    fontWeight: "500",
    bgcolor: "#F7F9FB",
    borderRadius: "0.75rem",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },

  disabledSelectItem: {
    textTransform: "capitalize",
    padding: "0.5rem",
    margin: "0 0.5rem",
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: "1.25rem",
  },

  select: {
    textTransform: "capitalize",
    height: "2.5rem",
    fontSize: "0.875rem",
    lineHeight: "1.5rem",
    fontWeight: "500",
    borderRadius: "0.75rem",
    "& .MuiOutlinedInput-notchedOutline": {
      // border: `1px solid ${theme.palette.custom.blueGray100}`,
      border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      // border: `1px solid ${theme.palette.custom.blueGray300}`,
      border: "none",
    },
  },

  selectMenuProps: {
    PaperProps: {
      sx: {
        marginTop: "1.1875rem",
      },
    },
  },

  selectItem: {
    textTransform: "capitalize",
    padding: "0.5rem",
    margin: "0 0.5rem",
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: "1.25rem",
    borderRadius: "0.75rem",
    "&:hover": {
      borderRadius: "0.5rem",
    },
  },

  tabsNavigation: {
    display: "flex",
    justifyContent: "space-between",
    textTransform: "none",
    "& .MuiTabs-flexContainer": {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "40px",
    },
    "& .MuiTabs-scroller": {
      marginTop: "15px",
    },
  },
  tabsNavigationIndicator: {
    backgroundColor: theme.palette.custom.mainBlue,
    height: "2px",
    borderRadius: 2,
    bottom: "10px",
  },

  tabsNavigationTab: {
    textTransform: "none",
    minWidth: "auto",
    minHeight: "auto",
    p: 0,
    m: 0,
    fontWeight: 600,
    lineHeight: "1.25rem",
    fontSize: "1rem",
  },

  tableContainer: {
    boxShadow: "none",
    bgcolor: theme.palette.custom.mainWhite,
    padding: "20px",
  },

  tableCellHead: {
    fontWeight: "600",
    fontSize: "1rem",
    lineHeight: "1.25rem",
    cursor: "pointer",
    borderBottom: "none",
  },

  tableCellBody: {
    borderBottom: "none",
    bgcolor: theme.palette.custom.mainWhite,
    display: "flex",
    alignItems: "center",
  },
  tableCellBodyContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.25rem",
  },
  ArrowsDiagram: {
    height: "24px",
    width: "24px",
    cursor: "pointer",
    marginLeft: "auto",
  },
};
